import { Helmet } from "react-helmet";
import React, { Component } from "react";
import "../../styles/depots/depots.scss";
import { Button, FormControl } from "react-bootstrap";
import DepotTable from "./depotTable";
import axios from "axios";
import { encodeQueryData, apiHost } from "../../api/apiClient";
import { Link } from "react-router-dom";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import queryString from "query-string";
import { connect } from "react-redux";
import RoleAccessBadge from "../common/roleAccessBadge";

class Depots extends Component {

  constructor(props) {
    super(props);
    this.state = {
      depotList: [],
      filteredDepotList: [],
      searchText: "",
      customerStatusFilter: "active",
      sortKey: "customerName",
      sortDirection: "asc",
    };
  }

  async componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    console.log("customerID", values.customerId);
    var urlAll = "";
    if (values.customerId) {
      this.customerId = values.customerId;
      let query = encodeQueryData(this.setCustomersQueryObject());
      urlAll = `${apiHost}/api/Depots/GetAllDepots?${query}`;
    } else {
      urlAll = `${apiHost}/api/Depots/GetAllDepots`;
    }

    this.props.setLoadingPageAction(true);
    try {
      const response = await axios.get(urlAll, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      response.data.sort((a, b) => {
        if (a.customerName.toLowerCase() < b.customerName.toLowerCase()) {
          return -1;
        } else if (a.customerName.toLowerCase() > b.customerName.toLowerCase()) {
          return 1;
        } else if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1;
        } else if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        } else {
          return 0;
        }
      })
      this.setState({ depotList: response.data, filteredDepotList: response.data });
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  }

  setCustomersQueryObject = () => {
    let data = {};
    data.SearchString = this.searchText;
    data.customerId = this.customerId;
    data.PageSize = this.pageSize;
    data.PageNumber = this.pageKey;
    data.SortDirection = this.sortDirection;
    data.SortString = this.sortString;
    return data;
  };

  handleSearch = (searchText) => {
    const search = searchText.trim().toLowerCase();
    const filteredDepotList = search
      ? this.state.depotList.filter((depot) => {
        const searchableText = [
          depot.name,
          depot.description,
          depot.customerName,
          depot.customerStatus,
          depot.timeZoneCity,
          depot.mapOverlay,
        ].join(" ").toLowerCase();

        return searchableText.includes(search);
      })
      : this.state.depotList;

    this.setState({ searchText, filteredDepotList });
  };

  handleSort = (sortKey) => {
    this.setState((prevState) => ({
      sortKey,
      sortDirection:
        prevState.sortKey === sortKey && prevState.sortDirection === "asc"
          ? "desc"
          : "asc",
    }));
  };

  handleCustomerStatusFilter = (customerStatusFilter) => {
    this.setState({ customerStatusFilter });
  };

  getCustomerStatus = (depot) => {
    return (depot.customerStatus || "Active").toString().toLowerCase();
  };

  getStatusFilteredDepots = () => {
    const { filteredDepotList, customerStatusFilter } = this.state;

    if (customerStatusFilter === "all") {
      return filteredDepotList;
    }

    return filteredDepotList.filter((depot) => this.getCustomerStatus(depot) === customerStatusFilter);
  };

  getStatusCounts = () => {
    const { filteredDepotList } = this.state;

    return filteredDepotList.reduce(
      (counts, depot) => {
        const status = this.getCustomerStatus(depot);

        counts.all += 1;

        if (status === "active") {
          counts.active += 1;
        }

        if (status === "disabled" || status === "disable") {
          counts.disabled += 1;
        }

        return counts;
      },
      { all: 0, active: 0, disabled: 0 }
    );
  };

  getSortValue = (depot, sortKey) => {
    if (sortKey === "dbUpdated") {
      return depot.dbUpdated ? new Date(depot.dbUpdated).getTime() : 0;
    }

    return (depot[sortKey] || "").toString().toLowerCase();
  };

  getDisplayDepots = () => {
    const { sortKey, sortDirection } = this.state;
    const direction = sortDirection === "asc" ? 1 : -1;

    return [...this.getStatusFilteredDepots()].sort((a, b) => {
      const aValue = this.getSortValue(a, sortKey);
      const bValue = this.getSortValue(b, sortKey);

      if (aValue < bValue) {
        return -1 * direction;
      }

      if (aValue > bValue) {
        return 1 * direction;
      }

      return 0;
    });
  };

  render() {
    const { searchText, customerStatusFilter, sortKey, sortDirection } = this.state;
    const values = queryString.parse(this.props.location.search);
    const displayDepots = this.getDisplayDepots();
    const statusCounts = this.getStatusCounts();
    const customerStatusFilters = [
      { key: "all", label: "All", count: statusCounts.all },
      { key: "active", label: "Active", count: statusCounts.active },
      { key: "disabled", label: "Disabled", count: statusCounts.disabled },
    ];
    const role = String(localStorage.getItem("role") || "").replace(/\s+/g, "").toLowerCase();
    const isSystemAdmin = role === "systemadmin";

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>All depots </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper depot-page">
              <div className="depot-page-header">
                <div>
                  <h2>Depots</h2>
                  <p>{isSystemAdmin
                    ? "Manage depot records, customer ownership and map overlay references."
                    : "View depot details and live-alert subscription settings."}</p>
                  {values.customerId && (
                    <a
                      className="depot-filter-pill"
                      onClick={() => localStorage.removeItem("customer")}
                      href="/depots"
                    >
                      <i className="fa fa-times"></i>
                      {values.customerName}
                    </a>
                  )}
                </div>
                {isSystemAdmin && <div className="depot-header-actions">
                  <RoleAccessBadge role="SystemAdmin" />
                  <Link to="/createDepot">
                    <Button className="depot-create-button" variant="primary">
                      <i className="fa fa-plus"></i>
                      Create new
                    </Button>
                  </Link>
                </div>}
              </div>

              <div className="depot-toolbar">
                <div className="depot-search">
                  <i className="fa fa-search"></i>
                  <FormControl
                    aria-label="Search depots"
                    onChange={(e) => this.handleSearch(e.target.value)}
                    placeholder="Search depots, customers, time zones or overlays"
                    value={searchText}
                  />
                  {searchText && (
                    <button onClick={() => this.handleSearch("")} type="button">
                      <i className="fa fa-times"></i>
                    </button>
                  )}
                </div>
                <div className="depot-status-filter" aria-label="Active customer filter">
                  <span>Active customer filter</span>
                  <div>
                    {customerStatusFilters.map((filter) => (
                      <button
                        className={customerStatusFilter === filter.key ? "active" : ""}
                        key={filter.key}
                        onClick={() => this.handleCustomerStatusFilter(filter.key)}
                        type="button"
                      >
                        {filter.label}
                        <strong>{filter.count}</strong>
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              <div className="customers depot-table-shell">
                <DepotTable
                  depots={displayDepots}
                  onSort={this.handleSort}
                  sortDirection={sortDirection}
                  sortKey={sortKey}
                  readOnly={!isSystemAdmin}
                />
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Depots);
